import { render, staticRenderFns } from "./GrievanceItemHeader.vue?vue&type=template&id=845c9858&scoped=true&"
import script from "./GrievanceItemHeader.vue?vue&type=script&lang=ts&"
export * from "./GrievanceItemHeader.vue?vue&type=script&lang=ts&"
import style0 from "./GrievanceItemHeader.vue?vue&type=style&index=0&id=845c9858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845c9858",
  null
  
)

/* custom blocks */
import block0 from "./GrievanceItemHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports